/* dl-collection.js — full-row trimming, infinite "Načíst další", Filtry drawer.
   2026-08-03 drawer upgrades (Hynek):
   · colour swatch chips for any filter whose values carry S&D swatch data (e.g. Barva)
   · "Barevná teplota" renders as the gradient dual-handle slider again (ported from
     sections/dl-cct-slider.liquid, white point 4000 K — same colour ramp)
   · price inputs actually apply (they were dead), prefilled + real placeholder
   Rollback = assets/dl-collection-js-backup-20260803e.txt */
(function(){
const $=(s,e=document)=>e.querySelector(s), $$=(s,e=document)=>[...e.querySelectorAll(s)];
const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const root=$("#dl-collection"); if(!root) return;
const grid=$("#dl-grid");
const cols=()=>getComputedStyle(grid).gridTemplateColumns.split(" ").length;

/* --- keep the last visible row complete --- */
function trim(){
  const cards=$$(".pcard",grid);
  cards.forEach(c=>c.hidden=false);
  const hasMore=!!$(".more .dl-more",root);   // re-read: load-more may have removed it
  const c=cols();
  if(hasMore && c>1){
    const rem=cards.length%c;
    // never hide so much that fewer than one full row remains
    if(rem && cards.length-rem>=c) cards.slice(cards.length-rem).forEach(x=>x.hidden=true);
  }
  const shown=cards.filter(x=>!x.hidden).length;
  const el=$("#dl-shown"); if(el) el.textContent=shown;
}
trim();
let rt=null,last=cols();
addEventListener("resize",()=>{clearTimeout(rt);rt=setTimeout(()=>{const c=cols();if(c!==last){last=c;trim();}},120)});

/* --- load more (appends, keeps rows full) --- */
async function loadMore(link){
  const btn=$("button",link); btn.textContent="Načítám…";
  const html=await (await fetch(link.href)).text();
  const doc=new DOMParser().parseFromString(html,"text/html");
  doc.querySelectorAll("#dl-grid .pcard").forEach(c=>grid.appendChild(c));
  const next=doc.querySelector(".more .dl-more");
  if(next){ link.href=next.href; btn.textContent=next.querySelector("button").textContent; }
  else { link.closest(".more").remove(); }
  history.replaceState(null,"",link.href.replace(/([?&])page=\d+/,"$1page=1"));
  trim();
}
document.addEventListener("click",e=>{
  const link=e.target.closest(".dl-more"); if(!link) return;
  e.preventDefault(); loadMore(link);
});

/* --- sort --- */
$("#dl-sort")?.addEventListener("change",e=>{
  const u=new URL(location.href); u.searchParams.set("sort_by",e.target.value); u.searchParams.delete("page");
  location.href=u.toString();
});

/* --- Filtry drawer, driven by Search & Discovery data --- */
const data=JSON.parse($("#dl-filter-data")?.textContent||"[]");
if(!data.length) return;

/* navigate to current URL with `param` replaced by `vals` (empty array clears it) */
function applyParam(param,vals){
  const u=new URL(location.href), sp=u.searchParams;
  sp.delete(param); sp.delete("page");
  vals.forEach(v=>sp.append(param,v));
  const qs=sp.toString();
  location.href=u.pathname+(qs?"?"+qs:"");
}

/* CCT colour ramp — same anchors as sections/dl-cct-slider.liquid, white point 4000 K */
const CCT_ANCHORS=[[1000,[233,76,34]],[1200,[236,82,36]],[1300,[240,96,38]],[1600,[252,138,42]],[1800,[255,168,58]],[1900,[255,178,68]],[2000,[255,190,82]],[2200,[255,205,108]],[2400,[255,222,140]],[2500,[255,236,178]],[2700,[255,248,228]],[3000,[255,255,255]],[4000,[255,255,255]],[5000,[224,234,251]],[10000,[188,213,250]]];
function cctColor(k){
  const A=CCT_ANCHORS;
  if(k<=A[0][0]) return "rgb("+A[0][1].join(",")+")";
  if(k>=A[A.length-1][0]) return "rgb("+A[A.length-1][1].join(",")+")";
  for(let i=0;i<A.length-1;i++){
    const lo=A[i],hi=A[i+1];
    if(k>=lo[0]&&k<=hi[0]){
      const t=hi[0]===lo[0]?0:(k-lo[0])/(hi[0]-lo[0]);
      const c=[0,1,2].map(j=>Math.round(lo[1][j]+(hi[1][j]-lo[1][j])*t));
      return "rgb("+c.join(",")+")";
    }
  }
  return "rgb(255,255,255)";
}
const kelvinOf=v=>{const n=parseInt(String(v).replace(/[^0-9]/g,""),10);return isNaN(n)?null:n};
const isCct=g=>/barevna_teplota/.test(g.param||"");
const hasSwatches=g=>g.values&&g.values.some(v=>v.sw||v.swi);

const scrim=document.createElement("div"); scrim.className="fscrim";
const dr=document.createElement("aside"); dr.className="fdrawer";
dr.innerHTML='<div class="fhead"><h3>Filtry</h3><button class="x" type="button" aria-label="Zavřít"><svg class="ic" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"></path></svg></button></div><div class="fbody"></div><div class="ffoot"><a class="clr" href="'+location.pathname+'">Zrušit vše</a><button class="go" type="button">Zobrazit produkty</button></div>';
$(".fbody",dr).innerHTML=data.map((g,i)=>{
  let body;
  if(g.type==="price_range"){
    const ph=g.rangeMax?("do "+g.rangeMax):"do";
    body='<div class="fprice"><input type="number" name="'+esc(g.param)+'.gte" placeholder="od"'+(g.min?' value="'+g.min+'"':'')+'><span class="dash">–</span><input type="number" name="'+esc(g.param)+'.lte" placeholder="'+esc(ph)+'"'+(g.max?' value="'+g.max+'"':'')+'></div>';
  } else if(isCct(g)&&g.values.filter(v=>kelvinOf(v.v||v.l)!=null).length>=2){
    body='<div class="cct" data-cct="'+i+'"></div>';
  } else if(hasSwatches(g)){
    body='<div class="fswrap">'+g.values.map(v=>{
      const chip=v.swi?'background-image:url('+esc(v.swi)+')':'background:'+esc(v.sw||"#ddd");
      return '<a class="fsw'+(v.active?" on":"")+'" href="'+v.u+'" title="'+esc(v.l)+'"><span class="swc" style="'+chip+'"></span><span class="n">'+esc(v.l)+'</span><span class="c">'+v.c+'</span></a>';
    }).join("")+'</div>';
  } else {
    body=g.values.map(v=>'<a class="fopt'+(v.active?" on":"")+'" href="'+v.u+'"><span class="cb"><svg class="ic" viewBox="0 0 24 24"><path d="m5 13 4 4 10-10"></path></svg></span><span class="n">'+esc(v.l)+'</span><span class="c">'+v.c+'</span></a>').join("");
  }
  return '<div class="fgrp'+(i<2||isCct(g)?" open":"")+'"><div class="gh">'+esc(g.label)+' <svg class="ic" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"></path></svg></div><div class="gb">'+body+'</div></div>';
}).join("");
document.body.append(scrim,dr);

/* --- CCT gradient dual-slider wiring --- */
$$(".cct",dr).forEach(el=>{
  const g=data[+el.dataset.cct];
  const stops=g.values.map(v=>({k:kelvinOf(v.v||v.l),val:v.v||v.l,active:v.active})).filter(s=>s.k!=null).sort((a,b)=>a.k-b.k);
  const N=stops.length; if(N<2){el.closest(".fgrp").remove();return;}
  const actIdx=stops.map((s,i)=>s.active?i:-1).filter(i=>i>-1);
  let minIdx=actIdx.length?Math.min(...actIdx):0;
  let maxIdx=actIdx.length?Math.max(...actIdx):N-1;
  const grad=stops.map((s,i)=>cctColor(s.k)+" "+(i/(N-1)*100).toFixed(2)+"%").join(", ");
  el.innerHTML='<div class="dlcct-ro"></div><div class="dlcct-tw"><div class="dlcct-track" style="background:linear-gradient(90deg, '+grad+')"> </div><div class="dlcct-veil dlcct-veil-l"> </div><div class="dlcct-veil dlcct-veil-r"> </div><button type="button" class="dlcct-thumb dlcct-thumb-min" aria-label="Minimální teplota"></button><button type="button" class="dlcct-thumb dlcct-thumb-max" aria-label="Maximální teplota"></button></div><div class="dlcct-scale"><span>'+stops[0].k+' K</span><span>'+stops[N-1].k+' K</span></div>';
  const tw=$(".dlcct-tw",el), vl=$(".dlcct-veil-l",el), vr=$(".dlcct-veil-r",el), tmin=$(".dlcct-thumb-min",el), tmax=$(".dlcct-thumb-max",el), ro=$(".dlcct-ro",el);
  const pct=i=>i/(N-1)*100;
  function paint(){
    tmin.style.left=pct(minIdx)+"%"; tmax.style.left=pct(maxIdx)+"%";
    vl.style.width=pct(minIdx)+"%"; vr.style.width=(100-pct(maxIdx))+"%";
    ro.innerHTML=(minIdx===0&&maxIdx===N-1)
      ? '<strong>Vše</strong><span class="sub">'+stops[0].k+'–'+stops[N-1].k+' K</span>'
      : stops[minIdx].k+' K <span class="sub">–</span> '+stops[maxIdx].k+' K';
  }
  function apply(){
    const full=(minIdx===0&&maxIdx===N-1);
    applyParam(g.param, full?[]:stops.slice(minIdx,maxIdx+1).map(s=>s.val));
  }
  function idxFromX(x){
    const r=tw.getBoundingClientRect();
    const p=Math.max(0,Math.min(1,r.width?(x-r.left)/r.width:0));
    return Math.round(p*(N-1));
  }
  let dragging=null;
  function onMove(e){ if(!dragging)return; const i=idxFromX(e.clientX);
    if(dragging==="min") minIdx=Math.min(i,maxIdx); else maxIdx=Math.max(i,minIdx); paint(); }
  function onUp(){ if(!dragging)return; dragging=null;
    document.removeEventListener("pointermove",onMove); document.removeEventListener("pointerup",onUp); apply(); }
  const start=w=>e=>{ e.preventDefault(); e.stopPropagation(); dragging=w;
    document.addEventListener("pointermove",onMove); document.addEventListener("pointerup",onUp); };
  tmin.addEventListener("pointerdown",start("min"));
  tmax.addEventListener("pointerdown",start("max"));
  tw.addEventListener("pointerdown",e=>{
    if(e.target===tmin||e.target===tmax) return;
    const i=idxFromX(e.clientX);
    if(Math.abs(i-minIdx)<=Math.abs(i-maxIdx)) minIdx=Math.min(i,maxIdx); else maxIdx=Math.max(i,minIdx);
    paint(); apply();
  });
  paint();
});

const btn=$("#dl-filters-open");
let activeCount=data.reduce((n,g)=>n+(g.values||[]).filter(v=>v.active).length,0);
data.forEach(g=>{ if(g.type==="price_range"&&(g.min||g.max)) activeCount++; });
if(activeCount){ btn.classList.add("has"); $(".bn",btn).textContent=activeCount; }
const open=()=>{scrim.classList.add("open");dr.classList.add("open");document.body.style.overflow="hidden"};
const close=()=>{scrim.classList.remove("open");dr.classList.remove("open");document.body.style.overflow=""};
btn.addEventListener("click",open); scrim.addEventListener("click",close);
$(".x",dr).addEventListener("click",close);
/* "Zobrazit produkty" applies the price inputs (they were previously dead), else just closes */
$(".go",dr).addEventListener("click",()=>{
  const pg=data.find(g=>g.type==="price_range");
  if(pg){
    const gte=$('input[name="'+pg.param+'.gte"]',dr), lte=$('input[name="'+pg.param+'.lte"]',dr);
    const u=new URL(location.href), sp=u.searchParams;
    const before=sp.toString();
    sp.delete(pg.param+".gte"); sp.delete(pg.param+".lte"); sp.delete("page");
    if(gte&&gte.value) sp.set(pg.param+".gte",gte.value);
    if(lte&&lte.value) sp.set(pg.param+".lte",lte.value);
    if(sp.toString()!==before){ const qs=sp.toString(); location.href=u.pathname+(qs?"?"+qs:""); return; }
  }
  close();
});
document.addEventListener("keydown",e=>{if(e.key==="Escape")close()});
$$(".gh",dr).forEach(h=>h.addEventListener("click",()=>h.parentElement.classList.toggle("open")));
})();
